module.exports = __webpack_public_path__ + "static/searchinput-context-dont-d228f96e4d21cab5feeb64de03dbebd5.png";